import {Box, Text, Flex} from '@chakra-ui/layout';
import {WidgetBoxWrapper} from './widget-box-wrapper';

interface ProductListingProps {
  totalAssetCustomersTransacted: number | null;
  price: string;
  startDate: string | null;
  endDate: string | null;
  currencySymbol: string;
  currencyPostFix: string;
  assetId?: string;
  showOfferingWindow?: boolean;
}

export const ProductListing: React.FC<ProductListingProps> = ({
  totalAssetCustomersTransacted,
  price,
  startDate,
  endDate,
  currencySymbol,
  currencyPostFix,
  assetId,
  showOfferingWindow = false,
}) => {
  return (
    <WidgetBoxWrapper>
      <Box p="16px" justifyContent="center" alignItems="center">
        {/* price per fraction exists */}
        <Flex justify="space-between" mb="10px">
          <Text textStyle="body4">
            Price per piece{' '}
            {assetId === 'valentines.day.mascara' ? 'including benefits' : ''}
          </Text>
          <Text textStyle="h6">
            {currencySymbol}
            {price}
            {currencyPostFix && currencyPostFix.length && (
              <Text as="span" fontSize="0.6em">
                {currencyPostFix}
              </Text>
            )}
          </Text>
        </Flex>

        {/* number of collectors  */}
        <Flex justify="space-between" mb={showOfferingWindow ? '10px' : 0}>
          <Text textStyle="body4">Number of Collectors</Text>
          <Text textStyle="body2">{totalAssetCustomersTransacted}</Text>
        </Flex>

        {/* intial offering window */}
        {showOfferingWindow && (
          <Flex as="p" justify="space-between">
            <Text as="span" textStyle="body4">
              Initial Offering Window
            </Text>
            <Flex>
              <Text
                as="span"
                textStyle="body7"
                bg="athensGrey"
                borderRadius="8px"
                px="6px"
              >
                {startDate}
              </Text>
              <Text as="span" px="4px" textStyle="body7">
                to
              </Text>
              <Text
                as="span"
                textStyle="body7"
                bg="athensGrey"
                borderRadius="8px"
                px="6px"
              >
                {endDate}
              </Text>
            </Flex>
          </Flex>
        )}
      </Box>
    </WidgetBoxWrapper>
  );
};
